import React, { useState, useEffect, useRef } from 'react';
import { useMediaQuery, Avatar, makeStyles, FormControl, InputLabel, Select, MenuItem, Button } from "@material-ui/core";
import { List, Datagrid, TextField, FunctionField, SimpleList } from 'react-admin';
import moment from "moment";
import { customTheme } from "./customTheme";
import { vehicleSvgs, hideName, hideVehicleNumber, hideMobileNumber as hideMobileMask } from "./sharedData";
import config from "./config.json";
// import DisplayColumnsButton from './components/DisplayColumnsButton';
import CustomDateTimePicker from "./components/CustomDateTimePickerV2";
import ScrollableTable from './components/ScrollableTable';
import CustomFilter from './components/CustomFilter';
import CustomSearch from './components/CustomSearch';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation, useHistory } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import PrivacyPasswordAuthentication from './components/CustomPrivacyPasswordAuth';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import PermitSummaryCard from './components/PermitSummaryCard'
import ShowTimePeriod from './components/ShowTimePeriod';
import { generateReport } from './utils/generateReports';
import GetAppIcon from "@material-ui/icons/GetApp";

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
    },
});

const PAYMENT_MODE_COLORS = {
    "CASH": "#e99100",
    "DIGITAL": "#109cf1",
};
const RFID_COLUMNS = {
    "Parking Name": false,
    "RFID": false,
    "Vehicle Number": true,
    "Type": true,
    "Name": true,
    "Amount": true,
    "Mobile": true,
    "Action": true,
    "Time": true,
    "Payment Method": true,
    "Status": true,
    "Company": true
};

const renderVehicleType = row => (
    row.vehicle_type ?
        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8 }} alt={row.vehicle_type_label} />
        </div>
        :
        null
);
const renderAction = action => {
    var color;
    switch (action) {
        case "ISSUE": color = customTheme.palette.primary.main; break;
        default: color = customTheme.palette.secondary.main;
    }

    return <div style={{ color }}>{action}</div>;
};
const renderActionForMob = action => {
    var color;
    switch (action) {
        case "ISSUE": color = customTheme.palette.primary.main; break;
        default: color = customTheme.palette.secondary.main;
    }

    return <div style={{ color }}><span style={{ color: "#5a5a5a" }}>Action: </span>{action}</div>;
};


const getSearchState = (searchObj) => {
    let newSearch = []
    for (let i in searchObj) {
        if (searchObj[i].showSearch) {
            newSearch.push(searchObj[i].name)
        }
    }
    return newSearch
}

const renderPaymentStatus = (record) => {
    if (record.payment_status === "CANCELLED") {
        return { style: { color: "#e99100", backgroundColor: "#e9910019" }, value: { status: record.payment_status } }
    }
    if (record.payment_status === "SUCCESS") {
        return { style: { color: "#18cc69", backgroundColor: "#18cc6919" }, value: { status: record.payment_status } }
    }
    if (record.payment_status === "INPROCESS" || record.payment_status === "INITIATED") {
        return { style: { color: "#e99100", backgroundColor: "#e9910019" }, value: { status: record.payment_status } }
    }
    if (record.payment_status === "FAILED") {
        return { style: { color: "#de575e", backgroundColor: "#de575e19" }, value: { status: record.payment_status } }
    }
    if (record.payment_status === "REFUNDED") {
        return { style: { color: "#109cf1", backgroundColor: "#109cf119" }, value: { status: record.payment_status } }
    }
    if (record.payment_status === "REFUND INITIATED") {
        return { style: { color: "#109cf1", backgroundColor: "#109cf119" }, value: { status: record.payment_status } }
    }
    return { style: { color: "#de575e", backgroundColor: "#de575e19" }, value: { status: record.payment_status } }
}

const CATEGORY = "PERMIT PAYMENT LOGS SECTION"

export const RfidPaymentsList = props => {
    const eventTracker = UseAnalyticsEvent()
    const navigate = useHistory()
    const classes = useStyles();
    const location = useLocation();
    const listDataRef = useRef();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    //const notify = useNotify();

    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [showRfidColumn] = useState(sessionStorage.getItem("show_rfid_column") === "1");
    //const [vehicleTypes, setVehicleTypes] = React.useState(Object.keys(featuresData.vehicle_type).map(type => ({ type, label: featuresData.vehicle_type[type].label, name: featuresData.vehicle_type[type].name })));
    const [displayColumns, setDisplayColumns] = useState(localStorage.getItem("rfidPaymentColumns") ? JSON.parse(localStorage.getItem("rfidPaymentColumns")) : RFID_COLUMNS);
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [startDateTimeFilter, setStartDateTimeFilter] = useState(null);
    const [endDateTimeFilter, setEndDateTimeFilter] = useState(null);
    const [summary, setSummary] = React.useState({ data: null, loading: true, count: 2 });
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [hideMobileNumber] = useState(sessionStorage.getItem("hide_mobile_number") === "1");
    const [showTiles, setShowTiles] = useState(true)


    const [privacyFeatureAccess, setPrivacyFeatureAccess] = useState(sessionStorage.getItem('privacy_feature_access') === "1")

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));


    let searchStateObject = [
        { name: "Vehicle Number", showSearch: true },
        { name: "Name", showSearch: true },
        { name: "Mobile", showSearch: true },
        { name: "Surface ID", showSearch: true },
        { name: "RFID", showSearch: showRfidColumn },
    ]
    let searchTypeState = getSearchState(searchStateObject)
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    let filterTypesInitState = [
        {
            resourcePath: "rfidOrganization",
            filterType: "Organization",
            dataList: [],
            searchList: [],
            listType: "Dynamic",
            resourceParam: "name",
            source: "organization",
            showFilter: true
        },
        {
            filterType: "Vehicle",
            dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Action",
            dataList: [{ name: "ISSUE", id: 2 }, { name: "RECHARGE", id: 3 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Display Columns",
            dataList: { "Parking Name": false, "RFID": false },
            listType: "CheckboxStatic",
            caseType: "CheckboxTypeStatic",
            showFilter: true,
            filterFormat: "Checkbox"
        },
    ]

    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const filter = { ...settingFilterFormat, start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

    const renderTime = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if (use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
    };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const setTimeFilters = () => {
        setStartDateTimeFilter(startDateTime);
        setEndDateTimeFilter(endDateTime);
    };

    const fomattingFilter = (filterList) => {
		const result = {};
		if (filterList) {
			for (const obj of filterList) {
				const { filterType, value, id } = obj;
				if (value && id) result[filterType.replaceAll(" ", "_").toLowerCase()] = { value, id };
			}
		}
		return result;
	}

    const reportParams = {
        access_key_ids: currentParking.allZones ? zoneIds : currentParking.id ? [currentParking.id] : undefined,
        report_name: "PERMIT_PAYMENTS",
        report_format: "xlsx",
        start_time: moment(startDateTime).format("YYYY-MM-DD HH:mm:ss"),
        end_time: moment(endDateTime).format("YYYY-MM-DD HH:mm:ss"),
        filters: filterListValue ? fomattingFilter(filterListValue) : undefined,
    };

    const reportHandler = async () => {
        const reportStatus = await generateReport(reportParams)
        if(reportStatus.success) navigate.push("/reports")
        else notify(reportStatus.message, "warning")
    }

    useEffect(() => {
        eventTracker(CATEGORY, " PERMIT PAYMENT LOGS LIST")
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setSummary({ ...summary, data: null, loading: true });
        fetch(`${config.HOST_NAME}/crm/rfidPaymentSummary?access_key_id=${filter.access_key}&zone_id=${filter.zone_id ? filter.zone_id : ""}&start_time=${startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : ""}&end_time=${endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : ""}&user_id=${sessionStorage.getItem("user_id")}&vehicle_type=${settingFilterFormat.vehicle_type}&action=${settingFilterFormat.action}&organization=${settingFilterFormat.organization}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(responseJson => {
                if (responseJson.success) {
                    responseJson.data.rechargeGraphData = []
                    responseJson.data.issueGraphData = []
                    responseJson.data.paymentsGraphData.map((val) => responseJson.data.rechargeGraphData.push({ x: val.hourly_time, y: val.recharge_count }))
                    responseJson.data.paymentsGraphData.map((val) => responseJson.data.issueGraphData.push({ x: val.hourly_time, y: val.issue_count }))
                    setSummary({ loading: false, data: responseJson.data, count: Object.keys(responseJson.data.vehicleTypes).length });
                } else {
                    setSummary({ ...summary, loading: false });
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                setSummary({ ...summary, loading: false });
                notify('Error Fetching Summary', 'warning')
            });

    }, [settingFilterFormat, startDateTimeFilter, endDateTimeFilter, currentParking]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Organization") {
                    values = { ...values, organization: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Vehicle") {
                    values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
                if (filterListValue[val].filterType === "Action") {
                    values = { ...values, action: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps
    return (<div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter && <ParkingSearchSelector
                value={currentParking}
                onChange={onParkingChange}
                clearable={true}
                pathName={location.pathname}
            />}

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>

        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} onChange={setTimeFilters} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} defaultColumns={RFID_COLUMNS} storageKey="rfidPaymentColumns" displayColumns={displayColumns} setDisplayColumns={setDisplayColumns} />
            {hideMobileNumber && <PrivacyPasswordAuthentication privacyFeatureAccess={privacyFeatureAccess} setPrivacyFeatureAccess={setPrivacyFeatureAccess} />}
            <Button
                className='buttonStyle addBorderRadius'
                variant="contained"
                color="secondary"
                disableElevation
                size="small"
                onClick={reportHandler}
            >
                <GetAppIcon />
            </Button>
        </div>
        <ShowTimePeriod startDateTimeFilter={startDateTime} endDateTimeFilter={endDateTime} showTiles={showTiles} setShowTiles={setShowTiles} />
        {showTiles &&
            <div style={{ display: "grid", gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, justifyContent: "space-between", marginTop: 10 }}>
                <PermitSummaryCard
                    title="Issue"
                    data={summary.data}
                    getValue={data => data.issueCount}
                    getAmount={data => data.issueAmount ? `₹ ${data.issueAmount.toFixed(2)}` : `₹ 0`}
                    getDistributedLabels={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].issueCount > 0).map(type => data.vehicleTypes[type].name)}
                    getDistributedValues={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].issueCount > 0).map(type => data.vehicleTypes[type].issueCount)}
                    getDistributedIcons={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].issueCount > 0).map(type => vehicleSvgs[type])}
                    getDistributedAmount={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].issueAmount > 0).map(type => data.vehicleTypes[type].issueAmount)}
                    loading={summary.loading}
                    showDonutChart={true}
                />
                <PermitSummaryCard
                    title="Recharge"
                    data={summary.data}
                    getValue={data => data.rechargeCount}
                    getAmount={data => data.rechargeAmount ? `₹ ${data.rechargeAmount.toFixed(2)}` : `₹ 0`}
                    getDistributedLabels={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].rechargeCount > 0).map(type => data.vehicleTypes[type].name)}
                    getDistributedValues={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].rechargeCount > 0).map(type => data.vehicleTypes[type].rechargeCount)}
                    getDistributedIcons={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].rechargeCount > 0).map(type => vehicleSvgs[type])}
                    getDistributedAmount={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].rechargeAmount > 0).map(type => data.vehicleTypes[type].rechargeAmount)}
                    loading={summary.loading}
                    showDonutChart={true}
                />
            </div>
        }

        <List
            {...props}
            style={{ marginTop: 10 }}
            title="RFID Payments"
            bulkActionButtons={false}
            sort={{ field: 'timestamp', order: 'DESC' }}
            filter={filter}
            empty={false}
            actions={false}
            pagination={<CustomPagination setListData={(listData) => { listDataRef.current = listData }} />}
        >
            {isSmallDevice ?

                <SimpleList
                    leftIcon={row => displayColumns["Type"] && row.vehicle_type ? <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ width: 28, height: 28, marginTop: 8, marginRight: 10, overflow: "visible" }} /> : undefined}
                    primaryText={record => displayColumns["Vehicle Number"] && hideVehicleNumber(record.vehicle_number.toUpperCase())}
                    secondaryText={record => (<div>
                        {displayColumns["RFID"] && showRfidColumn && <div style={{ color: "#444" }}>{record.rfid}</div>}
                        {displayColumns["Parking Name"] && <div style={{ color: customTheme.palette.secondary.main }}>{record["parking_name"]}</div>}
                        {displayColumns["Name"] && record.name && <div><span style={{ color: "#5a5a5a" }}>Name: </span>{hideName(record.name)}</div>}
                        {displayColumns["Mobile"] && hideMobileNumber && privacyFeatureAccess === null ? <FunctionField source="mobile" label="Mobile No." render={record => {
                            return record["mobile"] !== null ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}><span style={{ color: "#5a5a5a", marginRight: 5 }}>Mob No: </span>{hideMobileMask(record["mobile"])}</div> : ""
                        }} />
                            : <FunctionField source="mobile" label="Mobile No." render={record => record["mobile"] !== null ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}><span style={{ color: "#5a5a5a", marginRight: 5 }}>Mob No: </span>{`${hideMobileMask(record["mobile"])}`}</div> : ""} />
                        }
                        {displayColumns["Amount"] && <div>{record["amount"] ? `Amount: ${record["amount"]}` : ""}</div>}
                        {displayColumns["Action"] && record.action && <div>{renderActionForMob(record["action"])}</div>}
                        {displayColumns["Time"] && record.timestamp && <div><span style={{ color: "#5a5a5a" }}>Time: </span>{renderTime(record.timestamp)}</div>}
                        {displayColumns["Payment Method"] && record.payment_method && <div><span style={{ color: "#5a5a5a" }}>Payment: </span>{record.payment_method}</div>}
                        {displayColumns["Company"] && record.organization && <div><span style={{ color: "#5a5a5a" }}>Company Name: </span>{record.organization}</div>}
                        {displayColumns["Status"] &&
                            <FunctionField
                                source="payment_status"
                                label="Status"
                                render={record => {
                                    let recordResult = renderPaymentStatus(record)
                                    return record ? <div style={{ margin: "6px 0px" }}>
                                        <div style={{ color: "#5a5a5a" }}>Payment Status: <span style={{ ...recordResult.style, padding: "1px 8px", borderRadius: 500 }}>{recordResult.value.status}</span></div>
                                    </div> : ""
                                }}
                            />
                        }
                    </div>)}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :

                <Datagrid component={ScrollableTable}>
                    {displayColumns["RFID"] && showRfidColumn && <TextField source="rfid" label="RFID" />}
                    {displayColumns["Vehicle Number"] && <FunctionField source="vehicle_number" label="Vehicle Number" render={record => record && record["vehicle_number"] !== null ? hideVehicleNumber(record["vehicle_number"]) : "-"} />}
                    {displayColumns["Type"] &&
                        <FunctionField
                            source="vehicle_type"
                            label="Type"
                            render={record => record && renderVehicleType(record)}
                            sortable
                        />
                    }
                    {displayColumns["Name"] && <FunctionField source='name' label='Name' render={(record) => record && record.name ? hideName(record.name) : '-'} />}
                    {/* <TextField source="mobile" label="Mobile No." /> */}
                    {displayColumns["Moible"] && hideMobileNumber && privacyFeatureAccess === null ? <FunctionField source="mobile" label="Mobile No." render={record => {
                        return record ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>{record["mobile"] !== null ? hideMobileMask(record["mobile"]) : ""}</div> : "-"
                    }} />
                        : <FunctionField source="mobile" label="Mobile No." render={record => record && record["mobile"] !== null ? hideMobileMask(record["mobile"]) : ""} />
                    }
                    {displayColumns["Amount"] && <FunctionField source="amount" label="Amount" render={record => record && record["amount"] != null ? `₹${parseFloat(record["amount"])}` : "-"} sortable={true} style={{ color: "#555" }} />}
                    {displayColumns["Action"] && <FunctionField source="action" label="Action" render={record => record && renderAction(record["action"])} />}
                    {displayColumns["Time"] && <FunctionField source="timestamp" label="Time" render={record => record && renderTime(record["timestamp"])} sortable={true} />}
                    {displayColumns["Payment Method"] &&
                        <FunctionField
                            source="payment_method"
                            label="Payment Method"
                            render={record => record &&
                                <div
                                    className={classes.chipCell}
                                    style={PAYMENT_MODE_COLORS[record.payment_method] ? { color: PAYMENT_MODE_COLORS[record.payment_method], backgroundColor: (PAYMENT_MODE_COLORS[record.payment_method] + "19") } : { color: "#555555", backgroundColor: "#55555519" }}
                                >
                                    {record.payment_method}
                                </div>
                            }
                            sortable={true}
                            style={{ display: "flex", justifyContent: "center" }}
                        />
                    }
                    {displayColumns["Status"] &&
                        <FunctionField
                            source="payment_status"
                            label="Status"
                            render={record => {
                                let recordResult = renderPaymentStatus(record)
                                return record ? <div style={{ textAlign: "center" }}>
                                    <div
                                        className={classes.chipCell}
                                        style={{ ...recordResult.style, marginBottom: "5px" }}
                                    >
                                        {recordResult.value.status}
                                    </div>
                                </div> : "-"
                            }}
                            style={{ display: "flex", justifyContent: "center" }}
                        />
                    }
                    {displayColumns["Company"] && <TextField source="organization" label="Company" />}
                    {displayColumns["Parking Name"] && <TextField source="parking_name" label="Parking Name" />}
                </Datagrid>
            }
        </List>
    </div >);
};